import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormControl } from "@angular/forms";

import { SearchFilterOptionModel } from "../../../models/search-filter-option.model";

@Component({
    selector: "[pcg-ng-categories-filter]",
    templateUrl: "./categories-filter.component.html"
})
export class CategoriesFilterComponent implements OnInit {
    public control: FormControl<Array<string>> = null;
    public options: Array<SearchFilterOptionModel> = [];
    public expanded: boolean = false;

    @Input()
    public label: string = null;

    @Input("control")
    public set controlSetter(value: FormControl<Array<string>>) {
        this.control = value;
    }

    @Input("options")
    public set optionsSetter(value: Array<SearchFilterOptionModel>) {
        this.options = value || [];
    }

    @Output()
    public onChange = new EventEmitter();

    public ngOnInit(): void {
        this.options.forEach(option => { option.selected = (this.control.value.indexOf(option.id) !== -1); });
        this.expanded = this.options.some(option => option.selected);
    }

    public onExpand(): void {
        this.expanded = !this.expanded;
    }

    public onToggle(option: SearchFilterOptionModel): void {
        if (option.selected) {
            if (this.control.value.indexOf(option.id) === -1) {
                this.control.value.push(option.id);
            }
        } else {
            this.control.value.splice(this.control.value.indexOf(option.id), 1);
        }

        this.onChange.emit();
    }
}
